import { useMemo } from "react";
import { PSelect, Select } from "./Select/Select";

type PCurrenciesSelect<T extends object> = {
  listOfValues: T[];
  value: PSelect["value"];
  onChange: PSelect["onChange"];
  label: string;
  color: string;
  baseColor: string;
  borderColor: string;
  expandedBorderColor?: string;
  currentId?: number;
  enableSearch?: boolean;
  searchableValues?: any;
  hideLogo?: boolean;
};

interface IBaseCurrency {
  id: any;
  currency: string;
  currencyLogo: string;
  isReceive?: boolean;
  isReceiveNetwork?: boolean;
  isToken?: boolean;
  currencyName?: string;
  networkName?: string;
  standard?: string;
  confirmations?: number;
  estimatedDurationInMins?: number;
}

export const CurrencyLogoDropdown = <T extends IBaseCurrency>(
  props: PCurrenciesSelect<T>
) => {
  const {
    listOfValues,
    value,
    onChange,
    label,
    color,
    baseColor,
    borderColor,
    expandedBorderColor,
    currentId,
    enableSearch = false,
    searchableValues,
    hideLogo = false,
  } = props;

  const options = useMemo(() => {
    return listOfValues.map((item) => ({
      label: (
        <div
          className={`flex flex-row justify-between  w-full ${item.isReceiveNetwork ? "mt-[5px]" : ""
            }`}
        >
          <div>
            <div className="flex items-center  gap-[10px]">
              {!hideLogo && item.currencyLogo ? ( // 👈 only render if not hiding and we have a src
                <img src={item.currencyLogo} className="max-h-[20px]" alt="" />
              ) : null}
              <span className="Body-S-Medium 2xl:Body-M-Medium 4xl:Body-XL-Medium text-text-base font-normal text-[12px]">
                {item.currency}
              </span>
            </div>
            {!item.isToken && item.isReceive && (
              <span
                className={`text-text-subtle text-[10px] ${item.id === currentId ? "max-w-[120px]  truncate block" : ""
                  }`}
              >
                {item.networkName} ({item.standard})
              </span>
            )}
          </div>
          <div className="">
            {item.isToken && item.isReceive && (
              <span className="text-[12px] text-text-subtle">
                {item.currencyName}
              </span>
            )}
            {!item.isToken && item.isReceive && (
              <div className=" flex flex-col gap-[0px] items-end">
                <span className="text-text-base text-[12px] font-normal">
                  = {item.estimatedDurationInMins} minutes
                </span>
                <span className="text-text-subtle text-[10px] ">
                  {item.confirmations} confirmations
                </span>
              </div>
            )}
          </div>
        </div>
      ),
      value: item.id,
    }));
  }, [listOfValues]);

  return (
    <Select
      label={label}
      options={options}
      value={value}
      color={color}
      borderColor={borderColor}
      expandedBorderColor={expandedBorderColor}
      baseColor={baseColor}
      onChange={(val: any) => onChange && onChange(val)}
      getOptionCls={(isActive: any) =>
        isActive ? "text-text-base text-[14px]" : "text-text-base text-[14px]"
      }
      enableSearch={enableSearch}
      searchableLabels={searchableValues}
      optionsHeader={
        <div className="w-full flex flex-row justify-between text-text-base text-[14px] cursor-default"></div>
      }
    />
  );
};
